// 设置函数，使用commit来提交mutations中状态值的改变，但是此时state的状态值还是没有改变，需要通过$dispatch来分配actions；
import * as types from './mutation-types'

export default {
  maskShow ({ commit }) {
    commit(types.MASK_SHOW)
  },
}



// WEBPACK FOOTER //
// ./src/store/actions.js